import { useEffect, useRef, useState } from "react";
import { services } from "@/mocks/albertData";

export default function Servicios() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicios" className="py-24 bg-[#06060a]" ref={ref}>
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#1a0a2e]/20 blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-[#c9a84c] text-sm tracking-widest uppercase font-medium mb-4">Lo que ofrezco</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white font-bold mb-4">
            Servicios de <span className="text-[#c9a84c]">Tarot</span>
          </h2>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            Cada servicio está diseñado para darte la claridad y orientación que necesitas en este momento de tu vida.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={service.id}
              className={`group relative p-6 bg-[#0f0f1a] border border-white/10 rounded-2xl hover:border-[#c9a84c]/50 transition-all duration-500 cursor-pointer ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Price badge */}
              <div className="absolute top-4 right-4 bg-[#c9a84c]/10 border border-[#c9a84c]/30 text-[#c9a84c] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                {service.price}
              </div>

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center bg-[#1a0a2e] rounded-xl mb-5 group-hover:bg-[#c9a84c]/10 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-[#c9a84c]`}></i>
              </div>

              {/* Content */}
              <h3 className="text-white font-semibold text-lg mb-2 pr-12">{service.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed mb-5">{service.description}</p>

              {/* Footer */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1 text-white/40 text-xs">
                  <i className="ri-time-line"></i>
                  <span>{service.duration}</span>
                </div>
                <button
                  onClick={scrollToContact}
                  className="text-[#c9a84c] text-xs font-semibold border border-[#c9a84c]/40 px-4 py-1.5 rounded-full hover:bg-[#c9a84c] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Reservar
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className={`text-center mt-12 transition-all duration-1000 delay-500 ${visible ? "opacity-100" : "opacity-0"}`}>
          <p className="text-white/50 text-sm mb-4">¿No sabes qué servicio elegir? Contáctame y te orientaré.</p>
          <button
            onClick={scrollToContact}
            className="px-8 py-3 bg-[#c9a84c] text-black font-bold text-sm rounded-full hover:bg-[#e0c06a] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Consulta Gratuita de 10 min
          </button>
        </div>
      </div>
    </section>
  );
}
